import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import Header from '../containers/Header';
import Login from '../containers/Login';
import Footer from './common/Footer';
import Auth from '../containers/Auth';
import Routes from './Routes';
import '../css/admin.css';

import Setting from '../containers/Setting';
import ForgotPassword from '../containers/ForgotPassword';
import ForgotPasswordCode from '../containers/ForgotPasswordCode';

interface AppProps extends React.Props<{}> {
  user: any;
  auth: any;
  authActions: any;
}

export default class App extends React.Component<AppProps, {}> {
  static propTypes = {
    user: PropTypes.any,
    auth: PropTypes.any,
    authActions: PropTypes.any.isRequired
  };

  componentWillMount() {
    this.props.authActions.getSession();
  }

  componentDidUpdate() {
    if (this.props.auth.isSignedOut) {
      window.location.href = '/';
    }
  }

  render() {
    return (
      <BrowserRouter>
        <div className="fit">
          <Header />
          <div id="wrapper">
            <div className="contentIn">
              {/* モフトレ設定画面 */}
              <Switch>
                <Route path="/settings.html" component={Setting} />
                {/* モフトレパスワード変更画面 */}
                <Route path="/forgot_password.html" component={ForgotPassword} />
                {/* モフトレパスワードリセット再登録画面 */}
                <Route path="/forgot_password_code.html" component={ForgotPasswordCode} />
                <Route exact={true} path="/" component={Login} />
                <Auth>
                  <Route path="/" component={Routes} />
                </Auth>
              </Switch>
              <Footer />
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.tsx